"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.getLoaderColor = void 0;

var _react = _interopRequireDefault(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _icon = _interopRequireDefault(require("../icon"));

var _loader = _interopRequireDefault(require("../loader"));

var _once = require("../_shared/once");

var _style = _interopRequireDefault(require("./style.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var cx = _bind["default"].bind(_style["default"]);

var warnAppearanceIcon = (0, _once.once)(function () {
  /*eslint-disable no-console, max-len */
  console.warn('Warning:', '<Button appearance="icon" />  is deprecated. Use <Icon /> https://uikit.xsolla.com/components/icon');
  /*eslint-enable */
});

var getLoaderColor = function getLoaderColor(appearance) {
  if (appearance === 'primary' || appearance === 'secondary' || appearance === 'alert') {
    return 'white';
  }

  if (appearance === 'flatten') {
    return 'blue';
  }

  return 'gray';
};

exports.getLoaderColor = getLoaderColor;

var Button = function Button(_ref) {
  var _ref$appearance = _ref.appearance,
      appearance = _ref$appearance === void 0 ? 'primary' : _ref$appearance,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'button' : _ref$type,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'md' : _ref$size,
      offset = _ref.offset,
      icon = _ref.icon,
      children = _ref.children,
      _ref$focused = _ref.focused,
      focused = _ref$focused === void 0 ? false : _ref$focused,
      _ref$fetching = _ref.fetching,
      fetching = _ref$fetching === void 0 ? false : _ref$fetching,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$reversed = _ref.reversed,
      reversed = _ref$reversed === void 0 ? false : _ref$reversed,
      _ref$initialIconColor = _ref.initialIconColor,
      initialIconColor = _ref$initialIconColor === void 0 ? 'blue' : _ref$initialIconColor,
      className = _ref.className,
      dataId = _ref.dataId,
      rest = _objectWithoutProperties(_ref, ["appearance", "type", "size", "offset", "icon", "children", "focused", "fetching", "disabled", "reversed", "initialIconColor", "className", "dataId"]);

  if (appearance === 'icon') {
    warnAppearanceIcon();
  }

  return /*#__PURE__*/_react["default"].createElement("button", _extends({}, rest, {
    className: cx('xsui-button', "xsui-button--appearance-".concat(appearance), "xsui-button--size-".concat(size), offset && "xsui-button--offset-".concat(offset), icon && 'xsui-button__icon', focused && 'xsui-button--focused', "xsui-button--color-".concat(initialIconColor), className),
    type: type,
    disabled: disabled,
    "data-id": dataId || rest['data-id']
  }), /*#__PURE__*/_jsx("div", {
    className: cx('xsui-button__wrapper')
  }, void 0, fetching && /*#__PURE__*/_jsx("div", {
    className: cx('xsui-button__wrapper--fetching')
  }, void 0, /*#__PURE__*/_jsx(_loader["default"], {
    color: getLoaderColor(appearance),
    size: "sm",
    fullscreen: true
  })), /*#__PURE__*/_jsx("div", {
    className: cx('xsui-button__content', fetching && 'xsui-button--fetching', reversed && 'xsui-button--reversed')
  }, void 0, icon && /*#__PURE__*/_jsx(_icon["default"], {
    name: icon
  }), children)));
};

var _default = Button;
exports["default"] = _default;